import { computed } from 'vue';
import { useCustomerProfileActivationState } from '@/components/customerProfile/hooks/useCustomerProfileActivationState.ts';
import { useAccountStore } from '@/store/modules/account/store.js';

export const useCustomerSearchAvailability = () => {
    const accountStore = useAccountStore();
    const { isReadActivated } = useCustomerProfileActivationState();

    const canUseCustomerSearchInAccount = computed(() => {
        const account = accountStore.contextAccount;

        // Search only the selected data-owning account, never its children or group accounts.
        return Boolean(
            account?.id &&
                isReadActivated.value &&
                !account.isParent?.() &&
                !account.account_manager
        );
    });

    return { canUseCustomerSearchInAccount };
};
